import { SmartArtStore } from '../store/smart-art-store';
import { SmartArtMutationAPI } from '../api/smart-art-mutation-api';
import { SmartArtProps } from '../props/shape/smart-art-props';
import { GraphicFrameBaseDataModel } from './graphic-frame-base-data-model';
import type { PageContext } from '../context/page-context';
import type { ISmartArtProps } from '../props/shape/smart-art-props';
import type { GroupShapeDataModel } from './group-shape-data-model';
import type { IEventManager } from '../manager/event-manager';
import type { ISmartArtData } from '../data';
import type { IShapeDataModel } from './shape-data-model';
import type { RestrictedDataModel } from './data-model';

export class SmartArtDataModel extends GraphicFrameBaseDataModel<ISmartArtData> {
    public store: SmartArtStore;
    public props: ISmartArtProps;
    public api: SmartArtMutationAPI;

    constructor(data: ISmartArtData, events: IEventManager, context: PageContext, public parent: GroupShapeDataModel) {
        super(data, events, context, parent);

        this.store = new SmartArtStore(data, this, events, context);
        this.props = new SmartArtProps(this.store.data, context);
        this.api = new SmartArtMutationAPI(this, events);
    }

    public get shapeList(): IShapeDataModel[] {
        return this.store.shapeList;
    }
}

export { type ISmartArtProps };
export type ISmartArtDataModel = RestrictedDataModel<SmartArtDataModel>;
